var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"custom-btn",attrs:{"size":_vm.size,"type":_vm.type},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }